import React from 'react';
import { Field, reduxForm } from 'redux-form';

class AppInfoForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inProgress: false,
    };
    this.renderInput = this.renderInput.bind(this);
    this.renderSelect = this.renderSelect.bind(this);
    this.renderCheckbox = this.renderCheckbox.bind(this);
    this.renderTextArea = this.renderTextArea.bind(this);
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  componentDidMount() {
    // console.log('AppInfoForm.componentDidMount');
  }

  static validate(values) {
    const errors = {};
    if (!values.name) {
      errors.name = 'Required';
    }

    if (!values.hostname) {
      errors.hostname = 'Required';
    }

    if (!values.checkURL) {
      errors.checkURL = 'Required';
    }

    return errors;
  }

  static warn(values) {
    const warnings = {};
    // if (values && values.email && values.email.indexOf('@readytouch.com') == -1) {
    //   warnings.email = 'Hmm, you are not using readytouch.com...'
    // }
    return warnings;
  }

  renderInput({
    input,
    label,
    placeholder,
    type,
    disabled,
    autoFocus,
    meta: { touched, error, warning },
  }) {
    if (typeof placeholder == 'undefined' && label) {
      placeholder = label;
    }
    return (
      <div className='pure-control-group'>
        <label>{label}</label>
        <input
          className='pure-input-1-2'
          {...input}
          placeholder={placeholder}
          type={type}
          disabled={disabled}
          autoFocus={autoFocus}
        />
        {touched &&
          ((error && <span style={{ paddingLeft: '10px', color: 'red' }}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    );
  }

  renderTextArea({ input, label, placeholder, type, disabled, meta: { touched, error, warning } }) {
    if (typeof placeholder == 'undefined' && label) {
      placeholder = label;
    }
    return (
      <div className='pure-control-group'>
        <label>{label}</label>
        <textarea
          className='pure-input-1-2'
          {...input}
          placeholder={placeholder}
          type={type}
          disabled={disabled}
        />
        {touched &&
          ((error && <span style={{ paddingLeft: '10px', color: 'red' }}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    );
  }

  renderSelect({ input, label, children, meta: { touched, error, warning } }) {
    return (
      <div className='pure-control-group'>
        <label>{label}</label>
        <select className='pure-input-1-2' {...input} placeholder={label}>
          {children}
        </select>
        {touched &&
          ((error && <span style={{ paddingLeft: '10px', color: 'red' }}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    );
  }

  renderCheckbox({ input, label, type, meta: { touched, error, warning } }) {
    return (
      <div className='pure-controls'>
        <label className='pure-checkbox'>
          <input {...input} type='checkbox' /> {label}
        </label>
        {touched &&
          ((error && <span style={{ paddingLeft: '10px', color: 'red' }}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    );
  }

  handleDeleteClick(e) {
    e.preventDefault(); // prevent form submit
    let id = this.props.initialValues.id;
    let checkURL = this.props.initialValues.checkURL;
    let isY = window.confirm("Delete '" + checkURL + "'?");
    if (isY && !this.props.initialValues.isCreate && this.props.onDelete) {
      this.setState({ inProgress: true }, () => {
        this.props.onDelete(id).then(() => {
          this.setState({ inProgress: false });
        });
      });
    }
  }

  handleCheckClick(e) {
    e.preventDefault(); // prevent form submit
    let id = this.props.initialValues.id;
    let checkURL = this.props.initialValues.checkURL;
    this.setState({ inProgress: true }, () => {
      this.props.onCheck(id, checkURL).then(() => {
        this.setState({ inProgress: false });
      });
    });
  }

  render() {
    const { handleSubmit, pristine, reset, submitting, initialValues } = this.props;
    // console.log('initialValues', initialValues);
    let isCreate = initialValues.isCreate;

    let inProgress = submitting || this.state.inProgress;

    return (
      <form
        className='kvs-form pure-form pure-form-aligned'
        style={{ padding: '20px 0', width: '600px' }}
        onSubmit={handleSubmit}
      >
        <fieldset>
          <input type='hidden' name='id' value={initialValues.id} />
          <Field
            name='name'
            component={this.renderInput}
            type='text'
            label='Name'
            autoFocus={true}
          />
          <Field name='hostname' component={this.renderInput} type='text' label='Hostname' />
          <Field
            name='description'
            component={this.renderTextArea}
            type='textarea'
            label='Description'
          />
          <Field name='checkURL' component={this.renderInput} type='text' label='Check URL' />
          <Field
            name='checkURLRequestMethod'
            component={this.renderInput}
            type='text'
            label='Request Method'
            placeholder='GET, POST, PUT or DELETE'
          />
          <Field
            name='checkURLRequestBody'
            component={this.renderTextArea}
            type='text'
            label='Request Body'
            placeholder=''
          />
          <Field
            name='checkURLRequestTimeoutSeconds'
            component={this.renderInput}
            type='text'
            label='Request Timeout Seconds'
          />
          <Field
            name='expectedStatusCode'
            component={this.renderInput}
            type='text'
            label='Expected Status Code'
          />
          <Field
            name='insideContainer'
            component={this.renderCheckbox}
            type='checkbox'
            label='Inside Container'
          />
          <Field
            name='checkResult'
            component={this.renderTextArea}
            type='textarea'
            label='Check Result'
            disabled={true}
          />
          <Field
            name='checkStatusCode'
            component={this.renderInput}
            type='text'
            label='Check Status Code'
            disabled={true}
          />
          <Field
            name='checkDate'
            component={this.renderInput}
            type='text'
            label='Check Date'
            disabled={true}
          />
          <Field
            name='prevCheckResult'
            component={this.renderTextArea}
            type='textarea'
            label='Previous Check Result'
            disabled={true}
          />
          <Field
            name='prevCheckStatusCode'
            component={this.renderInput}
            type='text'
            label='Previous Check Status Code'
            disabled={true}
          />
          <Field
            name='prevCheckDate'
            component={this.renderInput}
            type='text'
            label='Previous Check Date'
            disabled={true}
          />
          <Field
            name='isDisabled'
            component={this.renderCheckbox}
            type='checkbox'
            label='Disabled'
          />
          <div className='pure-controls'>
            <button
              style={{ margin: '0 10px' }}
              className='pure-button pure-button-primary'
              type='submit'
              disabled={inProgress}
            >
              {isCreate ? 'Create' : 'Update'}
            </button>
            {!isCreate && (
              <button
                style={{ margin: '0 10px' }}
                className='pure-button pure-button-danger'
                disabled={inProgress}
                onClick={this.handleDeleteClick.bind(this)}
              >
                Delete
              </button>
            )}
            {!isCreate && (
              <button
                style={{ margin: '0 10px' }}
                className='pure-button pure-button-danger'
                disabled={inProgress}
                onClick={this.handleCheckClick.bind(this)}
              >
                Check
              </button>
            )}
          </div>
        </fieldset>
      </form>
    );
  }
}

// Decorate the form component
// eslint-disable-next-line no-class-assign
AppInfoForm = reduxForm({
  form: 'AppInfoForm', // a unique name for this form
  validate: AppInfoForm.validate,
  warn: AppInfoForm.warn,
})(AppInfoForm);

export default AppInfoForm;



// WEBPACK FOOTER //
// ./src/components/AppInfoForm.js